/* @flow */
// $FlowIgnore
import { createStore, applyMiddleware, compose } from 'redux';
// $FlowIgnore
import thunk from 'redux-thunk';
// $FlowIgnore
import { apiMiddleware } from 'redux-api-middleware';
// $FlowIgnore
import { persistStore, persistReducer } from 'redux-persist';
// $FlowIgnore
import storage from 'redux-persist/lib/storage';

import reducers from './ducks/reducers';

let middleware = [thunk, apiMiddleware];
// $FlowIgnore
if (__DEBUG__) {
  // $FlowIgnore
  const createLogger = require('redux-logger');
  middleware = [...middleware, createLogger({
    collapsed: true,
  })];
}


const finalCreateStore = compose(
  applyMiddleware(...middleware),
  window.devToolsExtension ? window.devToolsExtension() : f => f,
)(createStore);

export default function configureStore(initialState: Object): Object {
  const persistConfig = {
    whitelist: ['notifications'],
    key: 'ncigdcSubmission',
    storage,
  };
  const persistedReducer = persistReducer(persistConfig, reducers);
  const store = finalCreateStore(persistedReducer, initialState);
  // $FlowIgnore
  if (__DEV__ && module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('ducks/reducers', () => {
      const nextRootReducer = require('ducks/reducers');
      store.replaceReducer(nextRootReducer);
    });
  }
  const persistor = persistStore(store);
  return { store, persistor };
}
